import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import UISelect from 'components/shared/UISelect'
import { FONT_FAMILY_OPTIONS } from 'components/Customize/OrgSettings/Constants'


class FontPicker extends Component {
  static propTypes = {
    fontFamily: PropTypes.string.isRequired,
  }

  render() {
    const { fontFamily, onSelection } = this.props
    return (
      <UISelect
          value={fontFamily}
          options={FONT_FAMILY_OPTIONS}
          onSelection={onSelection}
          optionRenderer={this.renderFont}
          valueRenderer={this.renderFont}
      />
    )
  }

  renderFont = ({label, value}) => {
    return (
      <div className={classNames('body-font', value)}>
        {label}
      </div>
    )
  }
}

export default FontPicker



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/FontPicker/index.js